import { exerciseDetailsActionTypes } from './Constants';
import { exerciseTypeCodes } from '../../services/Constants';

const initialState = {
	id: null,
	words: [],
	word_queue: {
		normal: [],
		incorrect: [],
		need_to_practise_words: [],
		in_progress: [],
		block_words: [],
		current_block_number: 1,
		learned_words_count: 0,
	},
	combined: false,
	mixed: false,
	currentListId: null,
	list_languages: {},
	special_characters: {},
	all_configuration: {},
	logic_parameters: {
		block_size: 1,
		max_words_in_progress: 1,
		new_word_count: 1,
	},
	exercise_types: [],
	exercise_type_code: '',
	show_onboarding: false,
	selected_words: [],
	list_ids: [],
	is_start: false,
	hint_type: null,
	isRestart: false,
	showFlag: true,
	settingsModal: {
		open: false,
	},
	exerciseTypes: {
		isDictateType: false,
		isToetsType: false,
		isHintsType: false,
		isInYourMindType: false,
		isMultipleChoiceType: false,
		isSpellingType: false,
		isLearningType: false,
		isMatchingType: false,
	},
	checkedWords: [],
	streaks: null,
	respData: null,
};

export default function exerciseDetailsReducer(state = initialState, action) {
	const { type, payload } = action;
	const { data, displayType, checkedWords, streaks } = payload || {};

	switch (type) {
		case exerciseDetailsActionTypes.START_EXERCISE_REQUEST:
			return {
				...state,
				loading: true,
				words: [],
				word_queue: {
					normal: [],
					incorrect: [],
					need_to_practise_words: [],
					in_progress: [],
					block_words: [],
					current_block_number: 1,
					learned_words_count: 0,
				},
			};

		case exerciseDetailsActionTypes.SKIP_ONBOARDING_REQUEST:
		case exerciseDetailsActionTypes.SAVE_SUBTYPE_REQUEST:
			return {
				...state,
				loading: true,
			};

		case exerciseDetailsActionTypes.SAVE_SETTINGS_REQUEST:
			return {
				...state,
				...data,
				all_configuration: data.allConfiguration,
			};

		case exerciseDetailsActionTypes.RESTART_EXERCISE_REQUEST:
			return {
				...state,
				...data,
				all_configuration: data.configuration,
				isRestart: true,
			};

		case exerciseDetailsActionTypes.START_EXERCISE_REQUEST_SUCCESS:
		case exerciseDetailsActionTypes.RESTART_EXERCISE_REQUEST_SUCCESS:
			return {
				...state,
				loading: false,
				is_start: false,
				hint_type: null,
				combined: false,
				isRestart: false,
				...data,
			};

		case exerciseDetailsActionTypes.SET_SELECTED_ITEMS:
		case exerciseDetailsActionTypes.SKIP_ONBOARDING_SUCCESS:
		case exerciseDetailsActionTypes.SET_HINT_TYPE:
		case exerciseDetailsActionTypes.SAVE_SUBTYPE_SUCCESS:
		case exerciseDetailsActionTypes.SET_IS_RESTART:
		case exerciseDetailsActionTypes.SET_CURRENT_LIST_ID:
			return {
				...state,
				...data,
			};

		case exerciseDetailsActionTypes.SEND_ANSWER_SUCCESS:
			return {
				...state,
				respData: data,
				streaks,
			};

		case exerciseDetailsActionTypes.RESUME_PAUSED_EXERCISE_SUCCESS:
			const isHintType = data.exercise_type_code === exerciseTypeCodes.HINTS;
			const hasHintSubType = !!data.all_configuration.subtype;

			return {
				...state,
				...data,
				list_ids: Object.keys(data.list_languages),
				hint_type: { value: data.all_configuration.subtype },
				loading: false,
				show_onboarding: isHintType ? !hasHintSubType : data.show_onboarding,
				is_start: false,
			};

		case exerciseDetailsActionTypes.SET_START_EXERCISE:
			return {
				...state,
				is_start: true,
				loading: false,
			};

		case exerciseDetailsActionTypes.CLEAR_STATE:
			return initialState;

		case exerciseDetailsActionTypes.TOGGLE_SETTINGS_MODAL:
			return {
				...state,
				settingsModal: data,
			};

		case exerciseDetailsActionTypes.HANDLE_EXERCISE_TYPES:
			return {
				...state,
				exerciseTypes: {
					isDictateType: exerciseTypeCodes.DICTATE === displayType,
					isToetsType: exerciseTypeCodes.FULL_WORD === displayType,
					isHintsType: exerciseTypeCodes.HINTS === displayType,
					isInYourMindType: exerciseTypeCodes.IN_YOUR_MIND === displayType,
					isMultipleChoiceType: exerciseTypeCodes.MULTIPLE_CHOICE === displayType,
					isSpellingType: exerciseTypeCodes.SPELLING === displayType,
					isLearningType: exerciseTypeCodes.LEARNING === displayType,
				},
			};

		case exerciseDetailsActionTypes.HANDLE_WORDS_TYPO_CHECKER_SUCCESS:
			return {
				...state,
				checkedWords,
			};

		case exerciseDetailsActionTypes.SAVE_SUBTYPE_ERROR:
		case exerciseDetailsActionTypes.SAVE_SETTINGS_ERROR:
		case exerciseDetailsActionTypes.SEND_ANSWER_ERROR:
		case exerciseDetailsActionTypes.SKIP_ONBOARDING_ERROR:
		case exerciseDetailsActionTypes.RESTART_EXERCISE_REQUEST_ERROR:
		case exerciseDetailsActionTypes.START_EXERCISE_REQUEST_ERROR:
			return {
				...state,
				loading: false,
			};
		default:
			return state;
	}
}
